/**
 * 售后中心-店铺预警-评价预警
 *  */ 
import { post, get, deleteApi, postJson } from '../axios'
import { getDetails } from './refundWaring';

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/negativeCommentWarning/'
const RESOURCE_BASE_PATH = '/negativeCommentWarning/'

// 查询评预警任务列表
export const queryTaskList = p => get(`${RESOURCE_BASE_PATH}`, p);

// 新增/编辑中差评预警任务
export const postTask = p => postJson(`${RESOURCE_BASE_PATH}`, p);

// 查询评预警短信记录
export const querySmsList = p => get(`${RESOURCE_BASE_PATH}short-message-record`, p);

// 查询详情
export const getDetail = id => get(`${RESOURCE_BASE_PATH}${id}`);

// 更新开启状态/优先级
export const stateSort = p => postJson(`${RESOURCE_BASE_PATH}state-sort`, p);

// 删除中差评预警任务
export const deleteTask = id => deleteApi(`${RESOURCE_BASE_PATH}${id}`);